






import Vue from 'vue'
import OrgList from '@/components/Orgs/OrgsList.vue'
export default Vue.extend({
  components: {
    OrgList
  }
})
